import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';

import { AccountReligionListComponent } from './account-religion-list.component';

@NgModule({
  declarations: [AccountReligionListComponent],
  imports: [CommonModule, TableModule, ButtonModule, RippleModule, InputTextModule],
  exports: [AccountReligionListComponent],
})
export class AccountReligionListModule {}
